import React, { useState, useEffect, useRef } from "react";
import "../styles.css";

const CoinFlipModal = ({ isOpen, onClose }) => {
  const [flipping, setFlipping] = useState(false);
  const [result, setResult] = useState(null);
  const coinRef = useRef(null);

  const flipCoin = () => {
    if (flipping) return;
    setFlipping(true);
    setResult(null);

    const outcome = Math.random() < 0.5 ? "HEADS" : "TAILS";

    // start animation: 5 full flips plus final half depending on outcome
    const fullSpins = 5;
    const endRotation = outcome === "HEADS" ? 0 : 180;
    const totalDeg = fullSpins * 360 + endRotation;

    coinRef.current.style.transition = "transform 2s";
    coinRef.current.style.transform = `rotateY(${totalDeg}deg)`;

    setTimeout(() => {
      setResult(outcome);
      setFlipping(false);
    }, 2000);
  };

  useEffect(() => {
    if (!isOpen) {
      setResult(null);
      setFlipping(false);
      // reset coin to heads
      if (coinRef.current) {
        coinRef.current.style.transition = '';
        coinRef.current.style.transform = 'rotateY(0deg)';
      }
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="modal-content coin-modal">
        <button className="modal-close" onClick={onClose}>×</button>
        <h2>Hod mincí</h2>
        <div className="coin-container">
          <div className="coin" ref={coinRef} onClick={flipCoin}>
            <div className="side heads">Panna</div>
            <div className="side tails">Orel</div>
          </div>
        </div>
        <button className="flip-btn" onClick={flipCoin} disabled={flipping}>
          {flipping ? "Točí se…" : "Hoď mincí"}
        </button>
        {result && (
          <div className={`result-display ${result.toLowerCase()}`}>
            🎉 Výsledek: <strong>{result === "HEADS" ? "Panna" : "Orel"}</strong>
          </div>
        )}
      </div>
    </div>
  );
};

export default CoinFlipModal;